import { starterFertilizer } from '@terraframing-suite/rx-config';
import { MenuItem } from '@mui/material';
import { InputsHeader } from '../InputsHeader';
import { Select } from '../form-controls';
import { Grid } from '../layout';

export function Year() {
  return (
    <>
      <InputsHeader title="Crop Year" />
      <Grid columns={2} columnSpacing={{ xs: 2, sm: 3 }}>
        <Select
          label="Planned Year"
          required
          name="starterFertilizer.plannedYear"
          defaultValue={new Date().getFullYear()}
        >
          {starterFertilizer.plannedYears.map((year) => (
            <MenuItem key={year} value={year}>
              {year}
            </MenuItem>
          ))}
        </Select>
      </Grid>
    </>
  );
}
